import React from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PrintButton } from "../../components/printButton";
import { t } from "../../localization/localization";

export default class Equipments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    axios.get(`${window._env_.BASE_URL}/gcris-api/equipment`).then((res) => {
      this.setState({
        data: res.data.map((e, i) => {
          return {
            index: i + 1,
            id: i + e.textvalue + e.crisId,
            ...e,
          };
        }),
      });
    });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    const options = {
      sizePerPage: 50,
      hideSizePerPage: true,
      hidePageListOnlyOnePage: true,
    };
    const columns = [
      {
        dataField: "index",
        text: "#",
        sort: true,
        headerStyle: { width: "60px" },
      },
      {
        dataField: "textvalue",
        text: t(locale, "/equipments/equipments/title"),
        sort: true,
        formatter: (cell, row) => {
          if (row.crisId) {
            return (
              <a
                target="_blank"
                href={`${window._env_.BASE_URL}/cris/equipment/${row.crisId}`}
              >
                {row.textvalue}
              </a>
            );
          } else {
            return row.textvalue;
          }
        },
      },
    ];

    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PrintButton />
        <BootstrapTable
          class={"w-auto"}
          bootstrap4
          striped
          condensed
          keyField="id"
          data={this.state.data}
          columns={columns}
          pagination={paginationFactory(options)}
          rowStyle={{ cursor: "pointer" }}
        />
      </div>
    );
  }
}
